import { css } from '../../styled-system/css'; // Adjust based on your path setup

export default function AuroraBackground() {
  return (
    <div
      class={css({
        position: 'absolute',
        inset: 0,
        overflow: 'hidden',
        bg: 'zinc.50',
        _dark: { bg: 'zinc.950' },
      })}
      style={{
        // Your Custom Teal & Mint Color Palette
        '--teal-base': '#26997b',
        '--mint-accent': '#00e39b',
        '--teal-dark': '#fff',
        '--teal-light': '#6ee7b7',
        '--mint-bright': '#a7f3d0',

        '--black': '#000',
        '--white': '#fff',
        '--transparent': 'transparent',

        // Gradient configurations using your new colors
        '--aurora': 'repeating-linear-gradient(100deg, var(--teal-dark) 5%, var(--teal-base) 15%, var(--mint-accent) 20%, var(--teal-light) 25%, var(--mint-bright) 30%)',
        '--dark-gradient': 'repeating-linear-gradient(100deg, var(--black) 0%, var(--black) 7%, var(--transparent) 10%, var(--transparent) 12%, var(--black) 16%)',
        '--white-gradient': 'repeating-linear-gradient(100deg, var(--white) 0%, var(--white) 7%, var(--transparent) 10%, var(--transparent) 12%, var(--white) 16%)',
      }}
    >
      <style>{`
        @keyframes aurora-wave {
          0% {
            background-position: 50% 50%, 50% 50%;
          }
          50% {
            background-position: 100% 100%, 100% 100%;
          }
          100% {
            background-position: 50% 50%, 50% 50%;
          }
        }
      `}</style>

      {/* Aurora Layer */}
      <div
        class={css({
          pointerEvents: 'none',
          position: 'absolute',
          inset: '-10px',
          opacity: 0.5,
          filter: 'blur(10px) invert(100%)',
          willChange: 'transform',
          backgroundImage: 'var(--white-gradient), var(--aurora)',
          backgroundSize: '300%, 200%',
          backgroundPosition: '50% 50%, 50% 50%',
          maskImage: 'radial-gradient(ellipse at 100% 0%, black 10%, var(--transparent) 70%)',
          WebkitMaskImage: 'radial-gradient(ellipse at 100% 0%, black 10%, var(--transparent) 70%)',

          _dark: {
            backgroundImage: 'var(--dark-gradient), var(--aurora)',
            filter: 'blur(10px) invert(0%)',
          },

          // Wave Pseudo-element
          _after: {
            content: '""',
            position: 'absolute',
            inset: 0,
            backgroundImage: 'var(--white-gradient), var(--aurora)',
            backgroundSize: '200%, 100%',
            backgroundAttachment: 'fixed',
            mixBlendMode: 'difference',

            _dark: {
              backgroundImage: 'var(--dark-gradient), var(--aurora)',
            },
          },
        })}
        style={{
          animation: 'aurora-wave 60s linear infinite',
        }}
      />
    </div>
  );
};
